import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ButtonModule } from '../button/index';

import { TryAgainComponent } from './try-again.component';

export { TryAgainComponent } from './try-again.component';

@NgModule({
  declarations: [
    TryAgainComponent
  ],
  imports: [
    ButtonModule
  ],
  exports: [
    TryAgainComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class TryAgainModule {}
